import pluralize from "pluralize";
import bytes from "bytes-iec";

export const pluralizeDeleteAssetsMessage = (count: number) =>
  `Are you sure you want to remove ${pluralize("asset", count, true)} from the playlist?`;

export const formatBytes = (bytesCount: number): string | null => {
  return bytes.format(bytesCount, { mode: "compatibility", decimalPlaces: 1, unitSeparator: " " });
};
